rdefine('app/products/properties/Section',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'',
        bindings:{
            textarea:{
                attr:{
                    placeholder:'model.name'
                },
                value:{
                    events:'change keyup summernote.change',
                }
            }
        },
        initialize:function(options) {
            this.cform = options.cform;
            this.bindings.textarea.value.data = 'cform.property_'+this.model.get("id");
            this.$el.html('<textarea class="form-control input-block-level"></textarea>');
            var height=parseInt(this.$el.css("height"));
            var sn = this.el;
            var cfg={
                disableDragAndDrop: true,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol']],
                    ['insert',['picture','link']],
                    ['view', ['fullscreen', 'codeview']]
                ],
                onChange: function(e) {
                    //set dirty
                    console.log("sd",e);
                    this.cform.set('property_'+this.model.get("id"))
                }.bind(this),
                callbacks: {
                    onImageUpload: function (files, editor, welEditable) {
                        $.each(files, function (i, file) {
                            sendFile(file, editor, welEditable, sn);
                        });
                        return false;
                    }
                },
                cleaner:{
                    notTime: 0, // Time to display Notifications.
                    action: 'both', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
                    newline: '<br>', // Summernote's default is to use '<p><br></p>'
                    notStyle: 'position:absolute;top:0;left:0;right:0', // Position of Notification
                    icon: '<i class="note-icon">[Your Button]</i>',
                    keepHtml: true, // Remove all Html formats
                    keepOnlyTags: ['<p>', '<br>', '<ul>', '<li>', '<b>', '<strong>','<i>', '<a>'], // If keepHtml is true, remove all tags except these
                    keepClasses: false, // Remove Classes
                    badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'html'], // Remove full tags with contents
                    badAttributes: ['style', 'start'] // Remove attributes from remaining tags
                }
            };
            setTimeout(function(){
                this.els=this.$el.find('textarea').summernote(cfg);
            }.bind(this),0);

        }
    });
});